import React, { useEffect, useState } from 'react';
import {Platform, Text, View, SafeAreaView, StyleSheet, Button, Alert, Modal, FlatList } from 'react-native'
import { useRoute } from '@react-navigation/native';
import { Video, AVPlaybackStatus } from 'expo-av';
import Constants from 'expo-constants';
import * as ScreenOrientation from 'expo-screen-orientation';


const videominheight = 400;

const ResourceReader = () => {

  const { params: {
    nombre,
    codigo,
    location
  }} = useRoute();

  const video = React.useRef(null);
  const SecondVideo = React.useRef(null);
  const [status1Video, setStatusV1] = React.useState({});
  const [status2Video, setStatusV2] = React.useState({});


  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);


  useEffect(() => {
    console.log("leer el json");

    var url = "www.json"

    if ( Platform.OS == 'web' )
    {
      console.log("WEB");
      fetch("https://raw.githubusercontent.com/Lozamded/NoRepo-SomeJson/main/misrecursos/"+ codigo +".json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
    }else
    {
      console.log("MOVIL");
      fetch("https://static.sumaysigue.uchile.cl/MatCon/Json/recursos/"+ codigo +".json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
    }
    
    console.log("leido")
  }, []);



  return (
    <SafeAreaView>
      <View style={styles.title}><Text>Viendo Recurso: {nombre}</Text></View>
      <View style ={styles.videoContainer}>
        <Text>Titulo del video: </Text>
        <Video
          style={styles.video}
          source={{
            uri: "https://static.sumaysigue.uchile.cl/MASonline/bundles/MEDIA%20RTA1/Resources/Clip_0.webm",
          }}
          resizeMode="contain"
          useNativeControls={true}
          />
      </View>      
      <Text>plataforma: {Platform.OS}</Text>
      {isLoading ? <View style={styles.content}><Text>Loading...</Text></View>  : 
        <View style={styles.content}>
          <Text style={{textAlign:"justify"}}>
            {data["contenido"]["texto1"]["esp"]}
          </Text>
          <Text style={{textAlign:"justify"}}>
            {data["contenido"]["texto2"]["esp"]}
          </Text>
          <View styles={styles.videoContainer} >
           
          </View>
          <Text style={{textAlign:"justify"}}>
            {data["contenido"]["texto3"]["esp"]}
          </Text>
        </View>
      }


    </SafeAreaView>
  );
    
};
  
  
  const styles = StyleSheet.create({
    title: {
      margin:  Platform.OS != 'web' ? Constants.statusBarHeight + 6 : 12,   
      marginTop: Platform.OS != 'web' ? Constants.statusBarHeight + 6 : 16,
      flexGrow: 1
    },
    content: {
      flex: 1,
      width: "100%",
      height: "100%",
      justifyContent:'space-between',
   
    },
    video: {
      alignSelf: 'center',
      minHeight: Platform.OS != 'web' ? 312 : 412,
      minWidth: Platform.OS != 'web' ?  412 : 600,
    },  
    videoContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: 'center',
      backgroundColor: '#ecf0f1',
      minHeight: Platform.OS != 'web' ?  412 : 600,
    },
    videoButtons: {
      margin: 10
    }
  })
  
  export default ResourceReader